import {
  OPEN_EDIT_RULE_NOTE,
  CLOSE_EDIT_RULE_NOTE,
  REQUEST_EDIT_RULE_NOTE,
  SUCCESS_EDIT_RULE_NOTE,
} from 'Store/Areas/Rule/EditRuleNoteActions';

const initialState = {
  loading: false,
  open: false,
  note: '',
};

export default function editRuleNoteReducer(state = initialState, action) {
  switch (action.type) {
    case OPEN_EDIT_RULE_NOTE:
    case CLOSE_EDIT_RULE_NOTE:
    case SUCCESS_EDIT_RULE_NOTE:
      return Object.assign({}, state, {
        loading: action.loading,
        open: action.open,
      });
    case REQUEST_EDIT_RULE_NOTE:
      return Object.assign({}, state, {
        loading: action.loading,
      });
    default:
      return state;
  }
}

